import React from 'react';
import styled from 'styled-components';

import colors from '../../../styles/colors';
import { ButtonLabel } from '../../../styles/generic';
import Spacings from '../../../styles/Spacings';

import CheckIcon from '../icons/CheckIcon';

import { StyledButtonProps, TagProps } from './Tags.types';

const Tag = ({ label, value, isActive, onClick, className }: TagProps) => (
  <StyledButton
    onClick={onClick ? () => onClick(value) : undefined}
    isActive={isActive}
    data-testid="tag"
    className={className}
  >
    {isActive && <StyledCheckIcon color={colors.white} />}
    {label}
  </StyledButton>
);

const StyledButton = styled.button<StyledButtonProps>`
  ${ButtonLabel}
  background-color: ${({ isActive, theme }) =>
    isActive ? theme.colors.abnGreen300 : 'transparent'};
  border: 1px solid ${({ theme }) => theme.colors.abnGreen300};
  border-radius: ${Spacings.M};
  color: ${({ isActive }) => (isActive ? colors.white : colors.abnLinkGreenB)};
  cursor: pointer;
  font-family: ${({ theme }) => theme.fontRegular};
  font-size: 14px;
  line-height: 20px;
  padding: ${Spacings.XS} 12px;
  transition: color 0.15s, background-color 0.15s;
  white-space: nowrap;

  &:hover {
    background-color: ${({ isActive }) =>
      isActive ? colors.abnLinkGreenB : colors.abnGreen50};
  }

  &:active {
    background-color: ${({ isActive, theme }) =>
      isActive ? theme.colors.abnGreen400 : colors.abnGreen55};
    border: 1px solid
      ${({ isActive, theme }) =>
        isActive ? theme.colors.abnGreen400 : theme.colors.abnGreen300};
    color: ${({ isActive, theme }) =>
      isActive ? colors.white : theme.colors.abnGreen300};
  }
`;

const TagList = styled.ul`
  display: flex;
  flex-wrap: wrap;
  gap: ${Spacings.XS};
  list-style: none;
  margin: 0;
  padding: 0;
`;

const TagListItem = styled.li`
  list-style: none;
  margin: 0;
  padding: 0;
`;

const StyledCheckIcon = styled(CheckIcon)`
  margin-right: ${Spacings.XS};
`;

export { Tag, TagList, TagListItem };
